module.exports = __webpack_public_path__ + "static/media/uw.e7137117.svg";